// extracted by mini-css-extract-plugin
export default {"deliveryZoneCardRoot":"deliveryZoneCardRoot___xyli9","deliveryZoneCardTitle":"deliveryZoneCardTitle___buDwq"};